import { createFileRoute } from '@tanstack/react-router';
import AuthGuard from '@/components/auth-guard';
import { TrendsDashboard } from '@/components/trends/trends-dashboard';
import { authClient } from '@/lib/auth-client';

export const Route = createFileRoute('/trends')({
  component: TrendsPage,
});

function TrendsPage() {
  const { data: session } = authClient.useSession();

  return (
    <AuthGuard requireAuth={true}>
      <div className="container mx-auto space-y-6 px-4 py-6">
        <div>
          <h1 className="font-bold text-2xl tracking-tight">
            Tendências Financeiras
          </h1>
          <p className="text-muted-foreground">
            Análise de tendências e padrões dos seus gastos
          </p>
        </div>

        <TrendsDashboard />
      </div>
    </AuthGuard>
  );
}
